var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthPriceGrey2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.9576 7.39453L4.57397 10.1869L10.9576 13.8142L17.3386 10.1869L10.9576 7.39453Z",
    fill: "#47596B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M4.57397 10.1871L10.9576 13.8145V0L4.57397 10.1871Z",
    fill: "#47596B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.9596 0V13.8145L17.3407 10.1871L10.9596 0Z",
    fill: "#47596B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M4.57397 11.3516L10.9576 20.0013V14.9789L4.57397 11.3516Z",
    fill: "#47596B"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M10.9596 14.9789V20.0013L17.3457 11.3516L10.9596 14.9789Z",
    fill: "#47596B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthPriceGrey2);
export default __webpack_public_path__ + "static/media/eth-price-grey-2.6bd1aef8.svg";
export { ForwardRef as ReactComponent };